import deDE from '@rover/app/locale/de-de/countries.json';
import esES from '@rover/app/locale/es-es/countries.json';
import frCA from '@rover/app/locale/fr-ca/countries.json';
import frFR from '@rover/app/locale/fr-fr/countries.json';
import itIT from '@rover/app/locale/it-it/countries.json';
import nbNO from '@rover/app/locale/nb-no/countries.json';
import nlNL from '@rover/app/locale/nl-nl/countries.json';
import svSE from '@rover/app/locale/sv-se/countries.json';
import allCountries from '@rover/constants/src/geography/countries.constants.json';
import { ACTIVE_COUNTRY_CODES } from '@rover/utilities/roverGeo.constants';

const DEFAULT_LOCALE = 'en-us';

const LOCALE_COUNTRIES: Record<string, Record<string, string>> = {
  'de-de': deDE as Record<string, string>,
  'es-es': esES as Record<string, string>,
  'fr-ca': frCA as Record<string, string>,
  'fr-fr': frFR as Record<string, string>,
  'it-it': itIT as Record<string, string>,
  'nb-no': nbNO as Record<string, string>,
  'nl-nl': nlNL as Record<string, string>,
  'sv-se': svSE as Record<string, string>,
};

export const getLocalizedCountries = async (locale: string): Promise<Record<string, string>> => {
  if (locale === DEFAULT_LOCALE) {
    return {};
  }
  return LOCALE_COUNTRIES[locale] ?? {};
};

/**
 * Get country options for a select field, filtered to only include countries where Rover operates
 * Uses localized country names when available
 */
export const getCountryOptions = async (
  locale: string = DEFAULT_LOCALE
): Promise<Array<{ value: string; label: string }>> => {
  const localizedCountries = await getLocalizedCountries(locale);

  // Filter to only countries where Rover operates
  const roverCountries = allCountries.filter((country) =>
    ACTIVE_COUNTRY_CODES.includes(country.code as (typeof ACTIVE_COUNTRY_CODES)[number])
  );

  // Map to select field options, using localized names when available
  return roverCountries.map((country) => ({
    value: country.code,
    label: localizedCountries[country.code.toLowerCase()] || country.name,
  }));
};
